import { getURLAssets } from "src/utils/urlHelper"

const host = getURLAssets();

export default {
  MYTASKS: `${host}/ui/myTasks.svg`
};